import React from "react";
import QuoteForm from "./QuoteForm";

export default function Contact() {
  return (
    <section className="contact-page">
      <div>
        <p className="eyebrow">Contact</p>
        <h1>Tell us what is coming in.</h1>
        <p>Share container count, freight type, location, and timing. Fairview CM can respond with crew planning and next steps.</p>
        <div className="contact-details">
          <span>quotes@fairviewcm.ca</span>
          <span>fairviewcm.ca</span>
          <span>fairviewcm.com</span>
        </div>
      </div>
      <QuoteForm embedded />
    </section>
  );
}
